import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from './../../common/common.module';
import { ChangeRequestForms } from './components/index';

@NgModule({
    declarations: [...ChangeRequestForms],
    exports: [...ChangeRequestForms],
    imports: [FormsModule, PlatformModule, CommonModule, AppCommonModule],
})
export class ChangeRequestsFormsModule {}
